import { FRONT_KEY } from '@Constants/frontKey';
import ProductOverviewPage from '@Local/Product/ProductOverviewPage';
import ProductAddPage from '@Local/Product/ProductAddPage';
import ProductDetailPage from '@Local/Product/ProductDetailPage';
import ProductEditPage from '@Local/Product/ProductEditPage';
import {
    PRODUCT_OVERVIEW_ROUTER,
    PRODUCT_ADD_ROUTER,
    PRODUCT_DETAIL_ROUTER,
    PRODUCT_EDIT_ROUTER,
} from '@Router/routerPath';

// 只有商品總覽給 href，新增、明細、編輯不出現在側邊選單
const productRouter = [
    {
        description: '商品管理',
        frontKey: FRONT_KEY.PRODUCT,
    },
    {
        description: '商品總覽',
        frontKey: FRONT_KEY.PRODUCT_OVERVIEW,
        static: true,
        exact: true,
        path: PRODUCT_OVERVIEW_ROUTER,
        href: PRODUCT_OVERVIEW_ROUTER,
        as: ProductOverviewPage,
    },
    {
        description: '新增商品',
        frontKey: FRONT_KEY.PRODUCT_ADD,
        static: true,
        exact: true,
        path: PRODUCT_ADD_ROUTER,
        as: ProductAddPage,
    },
    {
        description: '商品明細',
        frontKey: FRONT_KEY.PRODUCT_DETAIL,
        static: true,
        exact: true,
        path: PRODUCT_DETAIL_ROUTER,
        as: ProductDetailPage,
    },
    {
        description: '編輯商品',
        frontKey: FRONT_KEY.PRODUCT_EDIT,
        static: true,
        exact: true,
        path: PRODUCT_EDIT_ROUTER,
        as: ProductEditPage,
    },
];

export default productRouter;
